<template>
  <div class="c-document-item">
    <p class="h4">{{ capitalizeFirstLetter(new Date(data.date_start).toLocaleDateString('default', { month: 'long', year: 'numeric' })) }}</p>
    <c-document-row
      :data="data"
    />
    <div :id="`accordion-${data.id}`">
      <a
        data-toggle="collapse"
        :data-parent="`accordion-${data.id}`"
        :href="`#collapse-${data.id}`"
      >
        Файлы
      </a>
      <div
        :id="`collapse-${data.id}`"
        class="panel-collapse collapse"
      >
        <c-document-files
          :data="data.files"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CDocumentFiles from './CDocumentFiles.vue'
import CDocumentRow from './CDocumentRow.vue'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'

export default {
  name: 'CDocumentItem',
  components: {
    CDocumentFiles,
    CDocumentRow
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: { capitalizeFirstLetter }
}
</script>

<style scoped lang="scss">
  .c-document-item {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: #ddd 1px solid;
    div[id^="accordion"] {
      a {
        display: inline-block;
        margin-bottom: 5px;
      }
    }
  }
</style>
